export enum RespuestaValidaPago {

    CONTINUAR_RESUMEN = 'CONTINUAR_RESUMEN',
    AGENDAR_FECHA = 'AGENDAR_FECHA',
    URL_PAGO = 'URL_PAGO',
    ERROR_PRODUCTO_NO_ACEPTADO = 'ERROR_PRODUCTO_NO_ACEPTADO',
    ERROR_PRODUCTO_FECHA_AGENDAMIENTO_VENCIDA = 'ERROR_PRODUCTO_FECHA_AGENDAMIENTO_VENCIDA'
}
